import apiDtMood from './dtMoodApiHandler'
import { getDtMoodSession } from './dtmood-session.service'

const getBadges = () => {
  const dtMoodSession = getDtMoodSession()
  const clientId = dtMoodSession ? dtMoodSession.clientId : ''

  return new Promise((resolve, reject) => {
    apiDtMood
      .get(`/badges/list/?clientId=${clientId}`)
      .then((res) => {
        resolve(res)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

const getAwardsList = () => {
  const dtMoodSession = getDtMoodSession()
  const userId = dtMoodSession ? dtMoodSession.userId : ''

  return new Promise((resolve, reject) => {
    apiDtMood
      .get(`/awards/list/?userId=${userId}`)
      .then((res) => {
        resolve(res)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

export { getBadges, getAwardsList }
